import React from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./smallpotmodal.scss";

const SmallPotModal = (props) => {
  return (
    <div className="tax-free-ill-health-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">{props.headTitle}</div>
      <div className="sub-text">
        <p>{props.description}</p>
        {props.subDescription ? <p>{props.subDescription}</p> : ""}
        {props.question ? <h3 className="mt-4">{props.question}</h3> : ""}
      </div>
      <div className="text-end mt-5">
        {props.btnCloseName === "Close" ? (
          <Buttons
            className="secondary"
            name={props.btnCloseName}
            handleClick={props.handleCloseButton}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SmallPotModal;
